export enum ThreePLServiceStatusType {
  UNASSIGNED = "UNASSIGNED",
  ASSIGNED = "ASSIGNED",
  STARTED = "STARTED",
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED"
}
